import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-page" }
const _hoisted_2 = { class: "p-signin l-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "p-signin__ttl c-ttl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-signin__ttl__logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ]),
  /*#__PURE__*/_createTextVNode("ログイン")
], -1)
const _hoisted_4 = { class: "p-signin__field-container" }
const _hoisted_5 = {
  key: 0,
  class: "p-errors"
}
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "c-field__input" }
const _hoisted_11 = { class: "c-field" }
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = ["type", "maxlength"]
const _hoisted_15 = { class: "c-field has-mt" }
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = {
  class: "c-field__checkbox",
  for: "auto-signin-off"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "自動ログインを無効にする", -1)
const _hoisted_19 = { class: "c-field has-submit has-mt" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "c-field has-link has-mt" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "パスワードを忘れた方", -1)
const _hoisted_25 = { class: "p-signin__txt" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("アカウントをお持ちでない方は")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "新規会員登録", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.login, this)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.errorMsgRef)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("fieldset", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "username",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailRef) = $event)),
                    placeholder: "メールアドレス",
                    autocomplete: "email",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.emailRef]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.passwordToggle.fieldType,
                    name: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRef) = $event)),
                    maxlength: _ctx.PASSWORD_MAX_LENGTH,
                    placeholder: "パスワード",
                    autocomplete: "current-password",
                    required: ""
                  }, null, 8, _hoisted_14), [
                    [_vModelDynamic, _ctx.passwordRef]
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                  }, null, 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    name: "auto-signin-off",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.disableAutoLoginRef) = $event)),
                    id: "auto-signin-off"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.disableAutoLoginRef]
                  ]),
                  _hoisted_18
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "c-btn is-submit",
                disabled: !(_ctx.emailRef&&_ctx.passwordRef) || _ctx.isDeterringRef
              }, _hoisted_22, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { name: 'ResetPassword' },
                class: "c-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32),
      _createElementVNode("p", _hoisted_25, [
        _hoisted_26,
        _createVNode(_component_router_link, {
          class: "c-link c-link--primary",
          to: { name: 'Signup' }
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        })
      ])
    ])
  ]))
}